export default __webpack_public_path__ + "static/media/cr2.59e2f57f.jpg";